<div class="container-fluid">

  <form #ngF="ngForm" class="k-form-inline" [formGroup]="userStoryForm" #pForm action="#" style="width: 100%;">
    <div class="border-0 p-3 tile-css">

      <div class="k-form-field">
        <label for="title" class="form-label col-3">Title</label>
        <div class="col-8">
          <kendo-formfield showHints="always">
            <div class="k-form-field-wrap">
              <kendo-textarea class="AutosizeTextArea" formControlName="title" appAutoFocus></kendo-textarea>
            </div>

          </kendo-formfield>
        </div>
      </div>

      <div class="k-form-field">
        <label for="title" class="form-label col-3">Description</label>
        <div class="col-8">
          <kendo-formfield showHints="always">
            <kendo-editor formControlName="description"></kendo-editor>
          </kendo-formfield>
        </div>
      </div>

      <div class="k-form-field">
        <label class="form-label col-3">Story Type</label>
        <div class="col-8">
          <div class="component-container">
            <kendo-formfield showHints="always">
              <div>
                user story id: {{user_story_type_id_value}}<br>
              </div>
              <div class="k-form-field-wrap">
                <kendo-dropdownlist #storyType formControlName="user_story_type_id" [data]="storyTypes"
                  textField="user_story_type_description" valueField="id" [value]="selectedType"
                  [valuePrimitive]="true">
                  <ng-template kendoDropDownListItemTemplate let-dataItem>
                    <!-- <p>{{dataItem | json}}</p> -->
                    <fa-icon class="fa-solid fa-duotone {{dataItem.iconClass}}"
                      [icon]="['fad', dataItem.icon]"></fa-icon>
                    {{ dataItem!.user_story_type_description }}
                  </ng-template>
                  <ng-template kendoDropDownListValueTemplate let-dataItem>
                    @if(dataItem) {
                    <fa-icon class="fa-solid fa-duotone {{dataItem.iconClass}}"
                      [icon]="['fad', dataItem.icon]"></fa-icon>
                    {{ dataItem!.user_story_type_description }}
                    }
                    <!-- <p>{{dataItem | json}}</p> -->
                  </ng-template>
                </kendo-dropdownlist>
              </div>

            </kendo-formfield>

          </div>
        </div>
      </div>

      <div class="k-form-field">
        <label for="state" class="form-label col-3">Status</label>
        <div class="col-8">
          <div class="component-container">
            <kendo-formfield showHints="always">
              <!-- <div>
                user status id: {{user_story_status_id_value}}<br>
                user status: {{user_story_status_description_value}}
              </div> -->
              <kendo-dropdownlist #state formControlName="user_story_status_id" [data]="storyStatuses"
                [defaultItem]="{ text: 'Select state', value: null }" textField="user_story_status_description"
                valueField="id" [value]="selectedStatus" [valuePrimitive]="true">
              </kendo-dropdownlist>
            </kendo-formfield>
          </div>
        </div>
      </div>

      <div class="k-form-field">
        <label class="form-label col-3">Priority</label>
        <div class="col-8">
          <div class="component-container">
            <kendo-formfield showHints="always">
              <!-- <div>
                user priority id: {{user_story_priority_id_value}}<br>
                user priority: {{user_story_priority_description_value}}
              </div> -->
              <div class="k-form-field-wrap">
                <kendo-dropdownlist #storyPriority id="storyPriority" formControlName="user_story_priority_id"
                  [data]="storyPriorities" textField="user_story_priority_description" valueField="id"
                  [value]="selectedPriority" [valuePrimitive]="true">
                </kendo-dropdownlist>
              </div>

            </kendo-formfield>

          </div>
        </div>
      </div>

      <div class="k-form-field">
        <label class="form-label col-3">Estimate</label>
        <div class="col-8">
          <div class="component-container">
            <kendo-formfield showHints="always">
              <!-- <div>
                user estimate id: {{user_story_estimate_id_value}}<br>
                user estimate: {{user_story_estimate_description_value}}
              </div> -->
              <div class="k-form-field-wrap">
                <kendo-dropdownlist #estimate formControlName="user_story_estimate_id" [data]="storyEstimates"
                  textField="user_story_estimate_description" valueField="id" [value]="selectedPriority"
                  [valuePrimitive]="true">
                </kendo-dropdownlist>
              </div>

            </kendo-formfield>

          </div>
        </div>
      </div>

      <div class="k-form-field">
        <label class="form-label col-3">Requester</label>
        <div class="col-8">
          <div class="component-container">
            <kendo-formfield showHints="always">
              <!-- <div>
                user requester id: {{requested_by_user_id_value}}<br>
                user requester: {{requested_by_user_value}}
              </div> -->

              <div class="k-form-field-wrap">
                <kendo-dropdownlist #requester formControlName="requested_by_user_id" [data]="users"
                  textField="fullName" valueField="id" [valuePrimitive]="true">
                  <!-- <ng-template kendoDropDownListItemTemplate let-dataItem>
                    <span class="template">{{ dataItem.initials }}</span> {{ dataItem.fullName }}
                  </ng-template>
                  <ng-template kendoDropDownListValueTemplate let-dataItem>
                    <span class="template">{{ dataItem.initials }}</span> {{ dataItem.fullName }}
                  </ng-template> -->
                </kendo-dropdownlist>
              </div>

            </kendo-formfield>

          </div>
        </div>
      </div>

    </div>

  </form>
</div>
